import { Type } from "@angular/core";
import { Observable } from "rxjs";

export enum OverlayCategory {
  INCOMPATIBLE,
  BROKEN,
  INACTIVE,
}

export enum OverlayRule {
  ADVERTISING_API_ACCESS_LOST = "ADVERTISING_API_ACCESS_LOST",
  SB_NOT_SUPPORTED_FOR_KDP = "SB_NOT_SUPPORTED_FOR_KDP",
  SD_NOT_SUPPORTED_FOR_KDP = "SD_NOT_SUPPORTED_FOR_KDP",
  KEYWORD_TRACKER_NOT_SUPPORTED = "KEYWORD_TRACKER_NOT_SUPPORTED",
  SHARE_OF_VOICE_NOT_SUPPORTED = "SHARE_OF_VOICE_NOT_SUPPORTED",
  BIDDER_OFF_WHITELABEL = "BIDDER_OFF_WHITELABEL",
  BIDDER_OFF = "BIDDER_OFF",
  INVALID_SELLING_PARTNER_API_ACCESS = "INVALID_SELLING_PARTNER_API_ACCESS",
  MANUAL_ACTIVATION_REQUIRED = "MANUAL_ACTIVATION_REQUIRED",
  MARKETPLACE_NOT_INCLUDED = "MARKETPLACE_NOT_INCLUDED",
  START_FREE_TEST = "START_FREE_TEST",
  HOURLY_UNSUPPORTED_MARKETPLACE = "HOURLY_UNSUPPORTED_MARKETPLACE",
  HOURLY_NOT_IN_BILLING_PLAN = "HOURLY_NOT_IN_BILLING_PLAN",
  DSP_BIDDER_OFF = "DSP_BIDDER_OFF",
  DSP_NO_LINKED_ADVERTISER = "DSP_NO_LINKED_ADVERTISER",
  ONBOARDING_CALL_SCHEDULED = "ONBOARDING_CALL_SCHEDULED",
  SCHEDULE_ONBOARDING_CALL = "SCHEDULE_ONBOARDING_CALL",
  PROFIT_AND_LOSS_VENDOR_NOT_SUPPORTED = "PROFIT_AND_LOSS_VENDOR_NOT_SUPPORTED",
  PRODUCT_TOUR = "PRODUCT_TOUR",
}

export interface OverlayRuleConfig {
  category: OverlayCategory;
  applies: () => Observable<boolean>;
}

export type OverlayComponent = Type<unknown> & { readonly rule: OverlayRule };
